import AxiosInstance from '@src/Common/Services/Api/AxiosInstance';

/**
 *
 * @param idempotencyId is the PageName
 */
const AxiosInstanceUserFeedback = (idempotencyId: string) =>
  AxiosInstance(idempotencyId, process.env.API_USER_FEEDBACK_URL ?? '');
export default AxiosInstanceUserFeedback;
